import { api } from "@/lib/api";

export const providerKycApi = {
    summary: () => api.get("/provider/kyc").then((r) => r.data),
    upload: (payload) => api.post("/provider/kyc/documents", payload).then((r) => r.data),
    remove: (id) => api.delete(`/provider/kyc/documents/${id}`).then((r) => r.data),
    submit: () => api.post("/provider/kyc/submit").then((r) => r.data),
};

export const adminKycApi = {
    queue: (params = {}) => api.get("/admin/kyc", { params }).then((r) => r.data),
    summary: (pid) => api.get(`/admin/kyc/providers/${pid}`).then((r) => r.data),
    upload: (pid, payload) => api.post(`/admin/kyc/providers/${pid}/documents`, payload).then((r) => r.data),
    remove: (pid, id) => api.delete(`/admin/kyc/providers/${pid}/documents/${id}`).then((r) => r.data),
    decide: (pid, payload) => api.post(`/admin/kyc/providers/${pid}/decide`, payload).then((r) => r.data),
};
